var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.12349V16.5C13.5 17.3297 12.8297 18 12 18C11.1703 18 10.5 17.3297 10.5 16.5V5.12349L7.05938 8.56411C6.47344 9.15005 5.52188 9.15005 4.93594 8.56411C4.35 7.97817 4.35 7.02661 4.93594 6.44067L10.9359 0.440674C11.5219 -0.145264 12.4734 -0.145264 13.0594 0.440674L19.0594 6.44067C19.6453 7.02661 19.6453 7.97817 19.0594 8.56411C18.4734 9.15005 17.5219 9.15005 16.9359 8.56411L13.5 5.12349ZM3 16.5H9C9 18.1547 10.3453 19.5 12 19.5C13.6547 19.5 15 18.1547 15 16.5H21C22.6547 16.5 24 17.8454 24 19.5V21C24 22.6547 22.6547 24 21 24H3C1.34531 24 0 22.6547 0 21V19.5C0 17.8454 1.34531 16.5 3 16.5ZM20.25 21.375C20.5484 21.375 20.8345 21.2565 21.0455 21.0455C21.2565 20.8346 21.375 20.5484 21.375 20.25C21.375 19.9517 21.2565 19.6655 21.0455 19.4546C20.8345 19.2436 20.5484 19.125 20.25 19.125C19.9516 19.125 19.6655 19.2436 19.4545 19.4546C19.2435 19.6655 19.125 19.9517 19.125 20.25C19.125 20.5484 19.2435 20.8346 19.4545 21.0455C19.6655 21.2565 19.9516 21.375 20.25 21.375Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1c6cc505e26c7f5d739c5e4015f4e78b.svg";
export { ForwardRef as ReactComponent };